import axios from 'axios';
import client from './client';
import { useQuery } from '@tanstack/react-query';

export interface InferencesCount {
  message: string;
  data: {
    inference: {
      total: number;
    };
  };
}
const BASE_URL = 'https://apistats.virtuals.io';

/* export const getInferencesCount = async () => {
  const url = `${BASE_URL}/api/inferences/count`;
  const res = await client.get<InferencesCount>(url);

  return res.data;
}; */

export const getInferencesCount = (id?: string) =>
  axios
    .get<InferencesCount>(`${BASE_URL}/api/inferences/count`)
    .then((response: any) => response.data);

export const useGetInferencesCount = () =>
  useQuery({
    queryKey: ['getInterencesCount'],
    queryFn: () => getInferencesCount(),
  });
